<template>
  <div class="px-2 add_product">
    <v-app style="background: inherit">
      <div class="container addProductp px-0">
        <p class="mt-3 text-color" style="font-weight: bold">
          محصولات > اضافه کردن محصول
        </p>
        <div class="product-form mt-2 py-4">
          <div class="container">
            <h6 class="text-color mb-3">عکس محصول</h6>

            <div
              class="big-upload mt-1 pb-4 px-2"
              v-if="mainImage == '' || mainImage === null"
            >
              <div class="upload-locker">
                <img
                  src="/assets/site/images/seller-icons/upload.svg"
                  alt="image"
                />
              </div>
              <p class="my-text">
                برای گذاشتن عکس محصول برروی دکمه ی بارگذاری کلیک کنید
              </p>
              <p class="my-text">
                (حداقل اندازه ی تصویر 1600 1400 x و حداقل سایز 10mb)
              </p>
              <button class="my-button-2" @click="() => openInput(1)">
                بارگذاری
              </button>
            </div>
            <div class="image-showcase mt-1 pb-4" v-else>
              <div>
                <div class="showcase-locker">
                  <img :src="mainImage" class="showcase-image" alt="image" />
                  <div class="mt-3 text-center change-btn pb-3 mb-4">
                    <button @click="() => openInput(1)" class="my-button-2">
                      تغییر عکس اصلی
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <input
              type="file"
              id="getImage"
              class="hiddenInput"
              @change="(e) => addImage(e)"
              name="img"
              accept="image/*"
            />
          </div>
          <div class="container">
            <form action="">
              <div>
                <div class="text-color">نام محصول</div>
                <div class="mt-3">
                  <!-- <custom-input
                    style="background-color: white !important"
                    kind="text"
                    placeholder="نام محصول"
                    :initialEdit="editProduct.name"
                    container="full-width"
                    v-bind:theModel.sync="product.name"
                    classes="block full-width"
                  ></custom-input> -->
                  <v-text-field
                    solo
                    label="نام محصول"
                    v-model="product.name.value"
                  ></v-text-field>
                </div>
                <div class="">
                  <div class="text-color mb-2">موجودی</div>
                  <!-- <custom-input
                    style="background-color: white !important"
                    kind="text"
                    placeholder="موجودی(*)"
                    container="full-width"
                    v-bind:theModel.sync="product.remaining"
                    classes="block full-width"
                  ></custom-input> -->
                  <v-text-field
                    solo
                    v-model="product.remaining.value"
                  ></v-text-field>
                </div>
                <div class="">
                  <div class="text-color mb-2">قیمت(تومان)</div>
                  <!-- <custom-input
                    style="background-color: white !important"
                    kind="text"
                    placeholder="قیمت(تومان)(*)"
                    container="full-width"
                    v-bind:theModel.sync="product.price"
                    classes="block full-width"
                  ></custom-input> -->
                  <v-text-field
                    solo
                    v-model="product.price.value"
                  ></v-text-field>
                </div>

                <!--<div class="col-lg-6 col-md-12 mt-3"><custom-input kind="dropDown" :selectItems="subCategories" label="زیر دسته" container="full-width" v-bind:theModel.sync="product.subCat" classes="block full-width" placeholder="دسته بندی را انتخاب کنید"></custom-input></div>-->
                <div class="">
                  <div class="text-color mb-2">درصد تخفیف</div>

                  <!-- <custom-input
                    style="background-color: white !important"
                    kind="text"
                    placeholder="درصد تخفیف(*)"
                    container="full-width"
                    v-bind:theModel.sync="product.discount"
                    classes="block full-width"
                  ></custom-input> -->
                  <v-text-field
                    solo
                    v-model="product.discount.value"
                  ></v-text-field>
                </div>

                <!-- <div class="col-lg-6 col-md-12 mt-3"><custom-input kind="text" placeholder="کد تخفیف را وارد کنید" label="کد تخفیف" container="full-width" v-bind:theModel.sync="model" classes="block full-width"></custom-input></div> -->
                <div class="">
                  <div class="text-color mb-2">دسته بندی</div>
                  <!-- <custom-input
                    id="select"
                    @newSelect="changed"
                    style="background-color: white !important"
                    kind="dropDown"
                    :selectItems="categories1"
                    placeholder="دسته بندی(*)"
                    container="full-width"
                    v-bind:theModel.sync="product.category_id"
                    classes="block full-width"
                  ></custom-input> -->
                  <v-select
                    required
                    v-model="product.category_id.value.value"
                    item-text="name"
                    item-value="value"
                    :items="categories1"
                    label=""
                    solo
                  ></v-select>
                </div>
                <div>
                  <div class="text-color mb-2">برچسب ها</div>
                  <v-select
                    required
                    v-model="my_tag"
                    :items="tags"
                    item-text="text"
                    item-value="id"
                    label="برچسب ها"
                    solo
                  ></v-select>
                  <div>
                    <div
                      class="
                        my-text my-tag my-1
                        mx-1
                        d-inline-block
                        py-1
                        px-1
                        rounded
                      "
                      v-for="(tag, index) in filter_tags"
                      :key="index"
                    >
                      <div class="d-inline-block">
                        {{ tag.name }}
                      </div>
                      <div
                        class="px-1 py-1 d-inline-block pointer"
                        @click="removeTag(index, tag)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16.857"
                          height="17.857"
                          viewBox="0 0 16.857 17.857"
                        >
                          <g
                            id="Group_1416"
                            data-name="Group 1416"
                            transform="translate(-744.017 -87.017)"
                            opacity="0.86"
                          >
                            <g
                              id="Group_1314"
                              data-name="Group 1314"
                              transform="translate(746.136 89.136)"
                            >
                              <line
                                id="Line_263"
                                data-name="Line 263"
                                x1="12.618"
                                y2="13.618"
                                fill="none"
                                stroke="#585454"
                                stroke-linecap="round"
                                stroke-width="3"
                              />
                              <line
                                id="Line_264"
                                data-name="Line 264"
                                x1="13.618"
                                y2="12.618"
                                transform="translate(12.618 0) rotate(90)"
                                fill="none"
                                stroke="#585454"
                                stroke-linecap="round"
                                stroke-width="3"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-3 clearfix">
                  <div class="text-color mb-2">خصوصیت ها</div>
                  <div class="" :class="{ 'right half pl-2': show_child_attr }">
                    <v-select
                      required
                      v-model="selected_attrebute"
                      :items="my_attributes"
                      item-text="name"
                      item-value="id"
                      label="انتخاب خصوصیت"
                      solo
                    ></v-select>
                  </div>
                  <div v-if="show_child_attr" class="right half pr-2">
                    <v-select
                      :loading="loading_child_attr"
                      required
                      v-model="selected_child_attrebute"
                      :items="my_child_attributes"
                      item-text="name"
                      item-value="id"
                      label="انتخاب"
                      color="#eb307b"
                      solo
                    ></v-select>
                  </div>
                </div>
                <div v-if="let_it" class="mb-3">
                  <div
                    class="
                      my-text my-tag my-1
                      mx-1
                      d-inline-block
                      py-1
                      px-1
                      rounded
                    "
                    v-for="(badge, index) in my_attributes"
                    :key="index"
                    v-if="badge.chosen"
                  >
                    <div class="d-inline-block">
                      {{ badge.name }} : {{ badge.chosen.name }}
                    </div>
                    <div
                      class="px-1 py-1 d-inline-block pointer"
                      @click="removeBadge(badge)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.857"
                        height="17.857"
                        viewBox="0 0 16.857 17.857"
                      >
                        <g
                          id="Group_1416"
                          data-name="Group 1416"
                          transform="translate(-744.017 -87.017)"
                          opacity="0.86"
                        >
                          <g
                            id="Group_1314"
                            data-name="Group 1314"
                            transform="translate(746.136 89.136)"
                          >
                            <line
                              id="Line_263"
                              data-name="Line 263"
                              x1="12.618"
                              y2="13.618"
                              fill="none"
                              stroke="#585454"
                              stroke-linecap="round"
                              stroke-width="3"
                            />
                            <line
                              id="Line_264"
                              data-name="Line 264"
                              x1="13.618"
                              y2="12.618"
                              transform="translate(12.618 0) rotate(90)"
                              fill="none"
                              stroke="#585454"
                              stroke-linecap="round"
                              stroke-width="3"
                            />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="">
                  <p class="text-color">توضیحات</p>
                  <v-textarea
                    rows="5"
                    solo
                    placeholder="توضیحات مربوط به محصول را وارد کنید(حداکثر 500 کاراکتر)"
                    v-model="product.desc.value"
                    label=""
                  ></v-textarea>
                </div>
                <div class="pb-4 text-center w-100">
                  <button
                    class="my-button"
                    @click="(e) => submitProductSingle(e)"
                  >
                    ثبت محصول
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </v-app>
  </div>
</template>
<script>
import {
  ref,
  onMounted,
  watch,
  computed,
  reactive,
  inject,
} from "@vue/composition-api";
import CustomButton from "../../Common/customButton";
import IconImage from "../../Common/icon";
import CustomInput from "../../Common/CustomInput";
import ProductItem from "./partials/productItem";
import myTag from "../../Common/tag";
import Service from "../../../utils/seller-service";
import axios from "axios";
import Discount from "../../Main/Home/partials/Discount";

export default {
  components: {
    Discount,
    CustomButton,
    CustomInput,
    IconImage,
    ProductItem,
    myTag,
  },
  setup(props, context) {
    const authService = computed(() => {
      return Service(true);
    });
    const global = inject("global");
    const finalAttrs = ref([
      {
        theParentAttr: { value: null, valid: true },
        theChildAttr: { value: null, valid: true },
      },
    ]);
    const edit = ref(false);
    const subCategories = ref(null);
    const categories = ref(null);
    const product = reactive({
      name: { value: null, valid: true },
      price: { value: null, valid: true },
      remaining: { value: null, valid: true },
      category_id: { value: {}, valid: true },
      discount: { value: null, valid: true },
      desc: { value: null, valid: true },
      image: {},
      tag_id: [],
      attr_id: { value: [], valid: true },
      subCat: { value: "none", valid: true },
    });
    const editProduct = ref({
      name: { value: null, valid: true },
      price: { value: null, valid: true },
      remaining: { value: null, valid: true },
      category_id: { value: null, valid: true },
      discount: { value: null, valid: true },
      desc: { value: null, valid: true },
      image: { value: null, valid: true },
      tag_id: [],
      attr_id: { value: [], valid: true },
      subCat: { value: "none", valid: true },
    });
    const theParentAttr = computed(() => {
      if (finalAttrs.value.length > 1)
        return finalAttrs.value[finalAttrs.value.length - 1].theParentAttr;
      else return [];
    });
    const theChildAttr = computed(() => {
      if (finalAttrs.value.length > 1)
        return finalAttrs.value[finalAttrs.value.length - 1].theChildAttr;
      else return [];
    });
    const productToEdit = ref(null);

    onMounted(() => {
      getTags();
    });

    const reload = () => {
      window.location.reload();
    };
    const getChildAttrs = (i) => {
      authService.value.receive(
        "seller/attributechild/" + i,
        {},
        (s, d) => {
          if (s == 200) childAttrs.value.append(d.data);
          childAttrs.value.map((a) => {
            a.text = a.name;
            a.value = a.id;
          });
        },
        (s, e) => {}
      );
    };

    const getTags = () => {
      authService.value.receive(
        "seller/tags",
        {},
        (s, d) => {
          if (s == 200) tags.value = d.data;
          tags.value.map((t) => {
            t.text = t.name;
          });
          suggestedTags.value = d.data;
          suggestedTags.value.map((t) => {
            t.text = t.name;
          });
        },
        (s, e) => {
          console.log("this is error", e);
        }
      );
    };

    const attrs = ref(null);
    const childAttrs = ref(null);

    const items = [
      { text: "text1", value: "value1" },
      { text: "text2", value: "value2" },
      {
        text: "text2",
        value: "value2",
      },
      { text: "text2", value: "value2" },
      { text: "text2", value: "value2" },
      { text: "text2", value: "value2" },
    ];

    const model = ref(null);
    const tick = ref(false);
    const mainImage = ref(null);
    const extraImageToBeAdded = ref(null);
    const images = ref([]);
    const extraImages = ref([]);

    const tags = ref([
      { text: "دسته گل عروسی", id: 1 },
      { text: "گل ترحیم", id: 2 },
    ]);
    const suggestedTags = ref(null);

    const addTag = (t) => {
      product.tag_id = [...product.tag_id, t];
    };

    const openInput = (ni) => {
      if (ni == 1) document.getElementById("getImage").click();
      else document.getElementById("getExtraImage").click();
    };

    function addImage(e) {
      // let isSelected = images.value.length<1 ? true : false
      let isSelected = images.value.length < 2 ? true : false;

      if (isSelected) mainImage.value = URL.createObjectURL(e.target.files[0]);

      // images.value = [...images.value,{url:URL.createObjectURL(e.target.files[0]),isSelected:isSelected}]
      images.value = [
        { url: URL.createObjectURL(e.target.files[0]), isSelected: isSelected },
      ];

      product.image = e.target.files[0];
    }

    function addExtraImage(e) {
      extraImageToBeAdded.value = {
        image: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
      };
    }

    const selectImage = (i) => {
      images.value.map((m) => {
        m.isSelected = false;
      });

      images.value[i].isSelected = true;
      mainImage.value = images.value[i].url;
    };

    const submitProduct = (e) => {
      e.preventDefault();
      let f = new FormData();
      if (productToEdit.value != null) {
        var z = [];
        product.category_id.value.at.map((y) => {
          if (document.getElementById(y.name).checked) {
            var x = document.getElementsByName(y.name);

            console.log(x);
            for (let i = 0; i < x.length; i++) {
              if (document.getElementsByName(y.name)[i].checked) {
                z.push({
                  amount: document.getElementsByName(y.name)[i].id,
                  categoryId: y.id,
                });
              }
            }
          }
        });
        console.log(z);
        if (z.lenght === 1) {
          f.append("attribute_id", z[0].amount);

          // z.map((v, i) => {
          //   f.append('attribute_id[' + i + ']', v.amount)
          // })
        }
        f.append("name", product.name.value);
        if (productToEdit.value.price != product.price.value)
          f.append("price", parseInt(product.price.value));
        if (productToEdit.value.remaining != product.remaining.value)
          f.append("remain", parseInt(product.remaining.value));
        if (productToEdit.value.discount != product.discount.value)
          f.append("discount", parseInt(product.discount.value));
        if (productToEdit.value.desc != product.desc.value)
          f.append("desc", product.desc.value);
        if (productToEdit.value.category_id != product.category_id.value) {
          delete product.category_id.value.at;
          f.append("category_id", product.category_id.value.value);
        }
        if (!product.image.value) f.append("image", product.image);

        console.log(f.get("attribute_id"));
        authService.value.transmit(
          "seller/product/" + context.root.$route.params.id,
          f,
          () => {
            alert("تغییرات ثبت شد");
            location.reload();
          },
          (s, er) => {
            console.log({ er });
          }
        );
      } else {
        var z = [];
        product.category_id.value.at.map((y) => {
          if (document.getElementById(y.name).checked) {
            var x = document.getElementsByName(y.name);

            console.log(x);
            for (let i = 0; i < x.length; i++) {
              if (document.getElementsByName(y.name)[i].checked) {
                z.push({
                  amount: document.getElementsByName(y.name)[i].id,
                  categoryId: y.id,
                });
              }
            }
          }
        });

        if (z !== null) {
          z.map((v, i) => {
            f.append("attribute_id[" + i + "]", v.amount);
          });
        }

        f.append("name", product.name.value);
        f.append("price", parseInt(product.price.value));
        f.append("remain", parseInt(product.remaining.value));

        if (product.category_id.value != null) {
          f.append("category_id", parseInt(product.category_id.value.value));
        }

        f.append("discount", parseInt(product.discount.value));
        f.append("desc", product.desc.value);
        f.append("image", product.image);
        let myTags = [];
        product.tag_id.map((t) => {
          myTags.push(t.id);
        });
        // f.append('tag_id',myTags)
        myTags.map((v, i) => {
          f.append("tag_id[" + i + "]", v);
        });
        console.log(f.get("category_id"));
        console.log(f.get("attribute_id"));
        // console.log(f.get('category_id'))

        authService.value.transmit(
          "seller/product",
          f,
          () => {
            alert("با موفقیت ثبت شد!");
            location.reload();
          },
          (s, er) => {
            console.log({ er });
            if (!s) {
              er.response.data.error.invalid_params.map((err) => {
                if (err.field == "name") {
                  product.name.valid = false;
                  product.name.message = err.message;
                } else if (err.field == "remain") {
                  product.remaining.valid = false;
                  product.remaining.message = err.message;
                } else if (err.field == "price") {
                  product.price.valid = false;
                  product.price.message = err.message;
                } else if (err.field == "discount") {
                  product.discount.valid = false;
                  product.discount.message = err.message;
                } else if (err.field == "desc") {
                  product.desc.valid = false;
                  product.desc.message = err.message;
                } else if (err.field == "category_id") {
                  product.category_id.valid = false;
                  product.category_id.message = err.message;
                }
              });
            }
          }
        );
      }
    };

    const addNewAttr = (e) => {
      e.preventDefault();
      finalAttrs.value = [
        ...finalAttrs.value,
        {
          theParentAttr: { value: null, valid: true },
          theChildAttr: { value: null, valid: true },
        },
      ];
    };

    const assignAttrs = () => {
      var z = [];
      product.category_id.value.at.map((y) => {
        if (document.getElementById(y.name).checked) {
          var x = document.getElementsByName(y.name);

          console.log(x);
          for (let i = 0; i < x.length; i++) {
            if (document.getElementsByName(y.name)[i].checked) {
              z.push({
                amount: document.getElementsByName(y.name)[i].id,
                parentId: y.id,
              });
            }
          }
        }
      });

      if (z.length > 1) {
        for (let att = 0; att < z.length; att++) {
          f.append("attribute_id[" + att + "]", z[att].amount);
        }
      } else {
        f.append("attribute_id", z[0].amount);
      }
    };

    const refreshChilds = (x) => {
      getChildAttrs(x.value);
    };
    return {
      assignAttrs,
      productToEdit,
      extraImages,
      extraImageToBeAdded,
      addExtraImage,
      edit,
      refreshChilds,
      editProduct,
      addNewAttr,
      finalAttrs,
      product,
      childAttrs,
      theChildAttr,
      theParentAttr,
      subCategories,
      items,
      tags,
      addTag,
      suggestedTags,
      tick,
      openInput,
      images,
      mainImage,
      addImage,
      selectImage,
      categories,
      attrs,
      reload,
    };
  },
  computed: {
    authService() {
      return Service(true);
    },
  },
  data() {
    return {
      selectedAttribute: null,
      categories1: [],
      neededAttributes: [],
      neededOptions: [],
      my_attributes: null,
      selected_attrebute: null,
      my_child_attributes: true,
      selected_child_attrebute: null,
      show_child_attr: false,
      loading_child_attr: true,
      my_tag: null,
      filter_tags: [],
      let_it: true,
      ready_attribute: null,
    };
  },
  methods: {
    removeBadge(badge) {
      badge.chosen = "";
      this.let_it = false;
      this.let_it = true;
    },
    removeReadyBadge(badge, index) {
      this.ready_attribute.splice(index, 1);
    },
    removeTag(index, tag) {
      if (index > -1) {
        this.filter_tags.splice(index, 1);
      }
    },
    get_my_tag(tag) {
      return tag.id == this.my_tag;
    },
    filter_tag() {
      var this_object = this.tags.filter(this.get_my_tag);
      this.filter_tags.push(this_object[0]);
    },
    get_my_sub_attr(child_attr) {
      return child_attr.id == this.selected_child_attrebute;
    },
    filter_sub_attr() {
      const this_attributes = this.my_child_attributes.filter(
        this.get_my_sub_attr
      );
      this.my_attributes.forEach((element) => {
        if (element.id == this.fuckin_attributes[0].id) {
          element.chosen = this_attributes[0];
        }
      });
      // this.attr_badge[this.index_badge] = this_attributes[0];
    },
    get_my_attr(attr) {
      return attr.id == this.selected_attrebute;
    },
    filter_attr() {
      this.fuckin_attributes = this.my_attributes.filter(this.get_my_attr);
    },
    close_image(image) {
      this.authService.remove(
        "seller/product/image/" + image.id,
        {},
        (s, d) => {
          if (s == 200) alert("محصول پاک شد");
        },
        (s, e) => {}
      );
    },
    get_attrebutes() {
      this.authService.receive(
        "seller/attributes?category_id=1",
        {},
        (s, d) => {
          this.my_attributes = d.data;
        },
        (s, e) => {}
      );
    },
    get_child_attrebutes(id) {
      this.authService.receive(
        "seller/attributechild/" + id,
        {},
        (s, d) => {
          this.my_child_attributes = d.data;
          this.selected_child_attrebute = this.my_child_attributes[0].id;
          this.loading_child_attr = false;
        },
        (s, e) => {}
      );
    },

    check(id) {
      document.getElementById(id).checked = true;
      console.log(document.getElementById(id).checked);
    },
    getCateGories1() {
      axios
        .get("https://api.golpino.com/api/seller/categories")
        .then((resp1) => {
          this.categories1 = resp1.data.data;

          this.categories1.map((p) => {
            p.text = p.name;
            p.value = p.id;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getOptions1() {
      this.neededAttributes.map((c) => {
        axios
          .get("https://api.golpino.com/api/seller/attributechild/" + c.id)
          .then((resp3) => {
            this.neededOptions.push({ parent: c.id, option: resp3.data.data });
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },

    changed(e) {
      this.product.category_id.value = e;
      console.log(e);
      this.getAttributes1(e);
      setTimeout(this.getOptions1, 2000);
      console.log("e1");
    },
    submitProductSingle(e) {
      e.preventDefault();
      let f = new FormData();
      f.append("image", this.product.image);
      f.append("name", this.product.name.value);
      f.append("price", parseInt(this.product.price.value));
      f.append("remain", parseInt(this.product.remaining.value));
      f.append("discount", parseInt(this.product.discount.value));
      f.append("desc", this.product.desc.value);
      f.append("category_id", this.product.category_id.value.value);
      if (this.filter_tags) {
        this.filter_tags.forEach((element, index) => {
          f.append("tag_id[" + index + "]", element.id);
        });
      }
      var salam = -1;
      this.my_attributes.forEach((element, index) => {
        if (element.chosen) {
          var attr_index = salam + 1;
          f.append("attribute_id[" + attr_index + "]", element.chosen.id);
        }
      });
      this.authService.transmit(
        "seller/product",
        f,
        () => {
          alert("با موفقیت ثبت شد!");
          this.$router.push("/seller/products");
        },
        (s, er) => {
          console.log({ er });
          if (!s) {
          }
        }
      );
    },
    submitProduct(e) {
      e.preventDefault();
      let f = new FormData();
      if (this.productToEdit != null) {
        if (this.productToEdit.name != this.product.name.value)
          f.append("name", this.product.name.value);
        if (this.productToEdit.price != this.product.price.value)
          f.append("price", parseInt(this.product.price.value));
        if (this.productToEdit.remaining != this.product.remaining.value)
          f.append("remain", parseInt(this.product.remaining.value));
        if (this.productToEdit.discount != this.product.discount.value)
          f.append("discount", parseInt(this.product.discount.value));
        if (this.productToEdit.desc != this.product.desc.value)
          f.append("desc", this.product.desc.value);
        if (this.productToEdit.category_id != this.product.category_id.value) {
          f.append("category_id", this.product.category_id.value.value);
        }
        if (!this.product.image.value) f.append("image", this.product.image);

        this.authService.transmit(
          "seller/product/" + this.$route.params.id,
          f,
          () => {
            alert("تغییرات ثبت شد");
            location.reload();
          },
          (s, er) => {
            console.log({ er });
          }
        );
      } else {
        var z = [];
        if (this.product.category_id.value) {
          this.neededAttributes.map((y) => {
            var x = document.getElementsByName(y.name);
            for (let i = 0; i < x.length; i++) {
              if (document.getElementsByName(y.name)[i].checked) {
                z.push({
                  amount: document.getElementsByName(y.name)[i].id,
                  categoryId: y.id,
                });
              }
            }
          });
        }

        if (z !== null) {
          z.map((v, i) => {
            f.append("attribute_id[" + i + "]", v.amount);
          });
        }

        f.append("name", this.product.name.value);
        f.append("price", parseInt(this.product.price.value));
        f.append("remain", parseInt(this.product.remaining.value));

        if (this.product.category_id.value != null) {
          f.append(
            "category_id",
            parseInt(this.product.category_id.value.value)
          );
        }

        f.append("discount", parseInt(this.product.discount.value));
        f.append("desc", this.product.desc.value);
        f.append("image", this.product.image);
        let myTags = [];
        this.product.tag_id.map((t) => {
          myTags.push(t.id);
        });
        // f.append('tag_id',myTags)
        myTags.map((v, i) => {
          f.append("tag_id[" + i + "]", v);
        });
        console.log(f.get("category_id"));
        console.log(f.get("attribute_id"));

        this.authService.transmit(
          "seller/product",
          f,
          () => {
            alert("با موفقیت ثبت شد!");
            location.reload();
          },
          (s, er) => {
            console.log({ er });
            if (!s) {
              er.response.data.error.invalid_params.map((err) => {
                if (err.field == "name") {
                  this.product.name.valid = false;
                  this.product.name.message =
                    "نام محصول کمتر از 50 کاراکتر باشد";
                } else if (err.field == "remain") {
                  this.product.remaining.valid = false;
                  this.product.remaining.message =
                    "تعداد موجودی به انگلیسی و کمتر از 999999 باشد";
                } else if (err.field == "price") {
                  this.product.price.valid = false;
                  this.product.price.message =
                    "قیمت به انگلیسی و کمتر از 999999999 باشد";
                } else if (err.field == "discount") {
                  this.product.discount.valid = false;
                  this.product.discount.message =
                    "درصو تخفیف به انگلیسی و کمتر از 100 باشد";
                } else if (err.field == "desc") {
                  this.product.desc.valid = false;
                  this.product.desc.message =
                    "توضیحات کمتر از 500 کاراکتر باشد";
                } else if (err.field == "category_id") {
                  this.product.category_id.valid = false;
                  this.product.category_id.message =
                    "دسته بندی محصول را انتخاب کنید";
                } else if (err.field == "image") {
                  alert("عکس را آپلود کنید.");
                }
              });
            }
          }
        );
      }
    },
  },
  watch: {
    selected_attrebute(newValue, oldValue) {
      this.show_child_attr = true;
      this.loading_child_attr = true;
      this.get_child_attrebutes(newValue);
      this.filter_attr();
    },
    my_tag() {
      this.filter_tag();
    },
    selected_child_attrebute() {
      this.filter_sub_attr();
    },
  },
  mounted() {
    this.getCateGories1();
    // this.getAttributes1()
    // this.getOptions1()
    this.get_attrebutes();
    if (this.$route.params.id) {
      this.authService.receive(
        "seller/product/" + this.$route.params.id,
        {},
        (s, d) => {
          if (s == 200) {
            this.productToEdit = {};
            this.filter_tags = d.data.tag;
            this.productToEdit.name = d.data.product.name;
            this.productToEdit.price = d.data.product.price;
            this.productToEdit.remaining = d.data.product.remain;
            this.productToEdit.discount = d.data.product.discount;
            this.productToEdit.desc = d.data.product.desc;
            this.productToEdit.attributes = d.data.attribute;
            this.productToEdit.category_id = d.data.category.id;
            this.product.name = { value: d.data.product.name, valid: true };
            this.extraImages = d.data.images;
            this.product.category_id = {
              value: {
                id: d.data.category.id,
                value: d.data.category.id,
                name: d.data.category.name,
                text: d.data.category.name,
                at: [],
              },
              valid: true,
            };
            this.product.attributes = { value: d.data.attribute, valid: true };
            this.product.price = { value: d.data.product.price, valid: true };
            this.product.remaining = {
              value: d.data.product.remain,
              valid: true,
            };
            this.product.discount = {
              value: d.data.product.discount,
              valid: true,
            };
            this.product.desc = { value: d.data.product.desc, valid: true };
            this.mainImage = d.data.product.image;
            this.product.image = { value: d.data.product.image, valid: true };
            this.editProduct.name = this.productToEdit.name;
          } else {
            this.categories1.value.map((c) => {
              if (c.id) {
                if ((c.id = d.data.category.parent_id))
                  this.product.category_id.value = {
                    text: c.name,
                    value: c.id,
                  };
              }
            });
            this.product.subCat.value = {
              text: d.data.category.name,
              value: 1,
            };

            this.mainImage.value = d.data.product.image;
            this.product.discount = {
              value: d.data.product.discount,
              valid: true,
            };

            if (d.data.tag) {
              this.product.tag_id = [...d.data.tag];
              this.product.tag_id.map((tt) => {
                tt.text = tt.name;
                tt.value = tt.id;
              });
            }

            this.categories1.value.map((c) => {
              if ((c.id = d.data.category.parent_id))
                this.product.category_id.value = { text: c.name, value: c.id };
            });
            this.product.subCat.value = {
              text: d.data.category.name,
              value: 1,
            };
            if (d.data.product.attr_id) {
              this.product.attr_id = {
                value: [...d.data.product.attr_id],
                valid: true,
              };
            }

            this.finalAttrs.value = [];
            if (d.data.attribute) {
              d.data.attribute.map((ta) => {
                this.finalAttrs.value.push({
                  theParentAttr: { value: ta.parent_id, valid: true },
                  theChildAttr: { value: ta.id, valid: true },
                });
              });
              this.finalAttrs.value = d.data.attribute;
            }

            // let childCategori = getParrentCat(product.category_id.value)

            this.categories1.value.map((c) => {
              if (c.id == product.category_id.value) {
                this.product.category_id.value = c;
              }
            });
          }
        },
        (s, e) => {
          console.log("this is error", e);
        }
      );
    }
  },
};
</script>
<style lang="scss" scoped>
.add_product {
  .textarea.v-text-field.v-text-field--solo .v-input__control {
    textarea {
      min-height: 130px;
    }
  }
}
.container {
  max-width: 900px;
}
.close-image {
  width: 25px;
  height: 25px;
  padding: 4px;
  position: absolute;
  left: 4px;
  top: 4px;
  opacity: 0.6;
  background: #ffe5f634;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    opacity: 1;
    background: #8b58796e;
  }
}
.addProduct {
  font-weight: lighter;
}

.product-form {
  background-color: #fff;
  border-radius: 7px;
}

.purple-btn {
  text-align: center;
}

.purple-btn:hover {
  cursor: pointer;
}

.upload-extra {
  border: 2px dashed rgba(127, 127, 127, 0.4);
  padding: 0.5rem;
  border-radius: 10px;
}

.upload-extra h4 {
  font-size: 1rem;
}

.big-upload {
  text-align: center;
  border: 2px dashed #eb307b;
  font-size: 2.5vw;
  border-radius: 10px;
}
.add-image {
  border: 2px dashed rgba(127, 127, 127, 0.5);
  width: 100%;
  cursor: pointer;
}

.showcase-locker {
  overflow: hidden;
  position: relative;
  img {
    border-radius: 10px;
    max-height: 370px;
    width: 75%;
    margin: 0 auto;
    display: block;
  }
}
.change-btn {
  border-bottom: 1px solid gray;
  width: 60%;
  margin: 0 auto;
}
.showcase-locker:hover {
  cursor: pointer;
}

.selectedImage {
  border: 2px solid #772ce8;
}

.extra-image-locker {
  text-align: center;
  img {
    width: 65%;
    margin: 0 auto;
    display: block;
    border-radius: 10px;
  }
}

.selectedLocker {
  position: absolute;
  top: 3%;
  right: 5%;
}

.hiddenInput {
  position: absolute;
  visibility: hidden;
}

.productTag {
  border: 1px solid #772ce8;
  color: #772ce8;
  background-color: rgba(119, 44, 232, 0.16);
  border-radius: 5px;
}

.suggestion {
  color: #772ce8;
  font-size: 0.9rem;
  font-weight: lighter;
}

.suggestion:hover {
  cursor: pointer;
}

@media only screen and (min-width: 840px) {
  .attrs {
    padding: 1rem 0px 2rem 0px;
    border-top: 1px solid rgba(127, 127, 127, 0.3);
    border-bottom: 1px solid rgba(127, 127, 127, 0.3);
  }
}
@media only screen and (max-width: 500px) {
  .attrs {
    padding: 1rem 0px 2rem 0px;
    border-top: 1px solid rgba(127, 127, 127, 0.3);
    border-bottom: 1px solid rgba(127, 127, 127, 0.3);
    margin-top: 120px !important;
  }
}
@media only screen and (min-width: 500px) and (max-width: 840px) {
  .attrs {
    padding: 1rem 0px 2rem 0px;
    border-top: 1px solid rgba(127, 127, 127, 0.3);
    border-bottom: 1px solid rgba(127, 127, 127, 0.3);
    margin-top: 70px !important;
  }
}

.attrs button {
  width: auto !important;
  padding: 1rem;
}

@media only screen and (min-width: 700px) {
  .options {
    font-size: 16px;
    width: 150px;
  }
}

@media only screen and (max-width: 700px) {
  .options {
    font-size: 10px;
    width: 70px;
  }
}
.ml__2 {
  margin-left: -2px;
}
.white {
  background-color: white !important;
}
.added-pic {
  position: relative;
  width: 25%;
  margin-left: 4px;
  float: right;
  .showcase-image {
    width: 100%;
    height: 160px;
    border-radius: 10px;
  }
}
.my-tag {
  background: #ffddf1;
}
</style>
<style lang="scss">
.add_product {
  .v-input__control {
    min-height: 130px;
  }
}

.tagManager > input {
  background-color: white !important;
}
.upload-locker img {
  width: 70px;
}

@media only screen and (max-width: 700px) {
  .add_product {
    .extra-image-locker {
      img {
        width: 100%;
      }
    }
    .showcase-locker {
      img {
        width: 100%;
      }
    }
    .added-pic {
      width: 100%;
      img {
        height: auto;
        border-radius: 10px;
      }
    }
  }
  .right.half {
    width: 100%;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
.right.half {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>